
import { useContext, useEffect, useState } from "react";
import KrFormContext, { NavHeadingsKROEnum, KrFormContextLandslideType, LandslideKoluvia } from "../../../../contexts/krFormContext";
import { GetOptions } from "../../../../helpers/prepareForSelect";
import CheckboxMultiField from "../../../../components/checkboxMultiField/checkboxMultiField";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { FormSectionProps } from "./shared/types/formSectionProps";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { LabelChipClassType } from "../../../../components/shared/labelChip/types/labelChipProps";
import { AdditionalIcon } from "../../../../components/shared/additionalIcon/additionalIcon";
import { ReactComponent as addCircle } from '../../../../icons/add_circle.svg';
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";

const getSelected = (koluvia: any) => {
    return koluvia?.map((value: any) => {
        return value.rodzaJ_KOLUWIUM_SID as number
    })
}

const ColluvialMaterial = (props: FormSectionProps) => {

    var { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const [Error, setError] = useState<boolean>(false);
    const [ErrorMsg, setErrorMsg] = useState<string>('');
    const [koluviumSelected, setKoluviumSelected] = useState< number[] | undefined>(getSelected(krForm?.koluvia));

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            var errorMsg = krForm.config?.ValidationError!["koluvia"]
            if (errorMsg !== '') {
                setError(true);
                setErrorMsg(errorMsg);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var koluviumDict = GetOptions("RODZAJ_KOLUWIUM_SID", krForm.dictionaries, true);

    const onChangeCheckbox = (value: string | number | undefined, checked: boolean) => {
        var form = Object.assign({}, krForm);
        var Index: number = -1;
        var koluvium = form.koluvia?.find((koluvia, index) => {
            Index = index;
            return koluvia.rodzaJ_KOLUWIUM_SID === value
        });
        if (koluvium && !checked && Index > -1) {
            form.koluvia?.splice(Index, 1);
        }
        if (koluvium === undefined && checked) {
            if (form.koluvia === undefined) {
                form.koluvia = [];
            }

            var koluv: LandslideKoluvia = {
                rodzaJ_KOLUWIUM_SID: value as number,
                kolejnosc: 1,
                osuwiskO_GID: krForm.landslideAttributes?.globalid
            }
            form.koluvia?.push(koluv);
        }
        form.koluvia?.sort((a, b) => {
            if (a.rodzaJ_KOLUWIUM_SID && b.rodzaJ_KOLUWIUM_SID) return a.rodzaJ_KOLUWIUM_SID - b.rodzaJ_KOLUWIUM_SID
            return 0
        })
        form.koluvia?.forEach((koluv, index) => {
            koluv.kolejnosc = index + 1;
        })
        refreshValidation(krForm.koluvia);
        setkrForm(form);

        setKoluviumSelected(getSelected(form?.koluvia));
    }

    const refreshValidation = (values: LandslideKoluvia[] | undefined) => {
        const currValidation = createConfigValidation("koluvia", false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setError(true);
            setErrorMsg(currValidationMsg);
        } else {
            setError(false);
            setErrorMsg('');
        }
    }

    var addCommentBtn = getAddCommentBtnDetails(props.editMode!, KROFieldDict.matKoluw_rodzajKoluwiow, props.version === 1 ? "Rodzaj materiału" : "Rodzaj koluwiuw", props.setNewCommentFieldDetails!);

    if (props.collectiveEdition) {
        return (
            <>
                <h2>6. Materiał koluwialny</h2>
                <CollectiveSelectField top={true} value={koluviumSelected} isAuto={false} title={"Rodzaj koluwiów"}
                    forms={props.forms} keyName={CollectivePreviewKey.koluvia} actions={props.actions} single={false}
                    setActions={props.setActions} onDelete={props.onDelete} dic={koluviumDict} labelClass={LabelChipClassType.Checkbox}>
                    <CheckboxMultiField onChange={onChangeCheckbox} labelName={"Rodzaj koluwiów"} checkboxOptions={koluviumDict} selectedValues={koluviumSelected} />
                </CollectiveSelectField>
            </>
        )
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.ColluvialMaterial, props.getMapForNavScroll!)}>6. Materiał koluwialny</h2>
            <div style={{position: "relative"}} 
                ref={(node: any) => {getFieldRef(node, KROFieldDict.matKoluw_rodzajKoluwiow, props.getMapForComment!)}}
                onClick={() => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.matKoluw_rodzajKoluwiow); }}
            > 
                <CheckboxMultiField 
                    onChange={onChangeCheckbox} 
                    labelName={props.version === 1 ? "Rodzaj materiału" : "Rodzaj koluwiuw"} 
                    checkboxOptions={koluviumDict} 
                    selectedValues={koluviumSelected} 
                    error={Error} 
                    errorMsg={ErrorMsg} 
                    disableAllElements={!props.editMode}
                />
                {!props.editMode && 
                    <div 
                        className={`addCommentBtnWrapperRegular addCommentBtnWrapper ${props.markedFieldForCommentFiltering === KROFieldDict.matKoluw_rodzajKoluwiow ? "activeAddCommentBtn" : ""}`} 
                        onClick={addCommentBtn.onClick}>
                        {AdditionalIcon(addCircle)}
                    </div>
                }
            </div>
        </>
    )
}

export default ColluvialMaterial;